import { connect } from "react-redux";
import ResourceTab from ".";

const mapDispatchToProps = () => {
  return {
    
  };
};

export default connect(null, mapDispatchToProps)(ResourceTab);
